import api from "./api";

export const fetchCommissionRules = async () => {
    try {
        const response = await api.get(
            "/commission-rule-management/commission-rules"
        );

        if (
            response.status === 200 &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };
    } catch (error) {
        console.error(
            "Error fetching commission rules:",
            error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch commission rules",
        };
    }
};


export const createCommissionRule = async (
    payload
) => {
    try {
        const response = await api.post(
            "/commission-rule-management/commission-rules",
            payload
        );

        if (
            (response.status === 200 ||
                response.status === 201) &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
                message:
                    response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };
    } catch (error) {
        console.error(
            "Error creating commission rule:",
            error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to create commission rule",
        };
    }
};

export const updateCommissionRule =
    async (
        commissionRuleId,
        payload
    ) => {
        try {
            const response =
                await api.put(
                    `/commission-rule-management/commission-rules/${commissionRuleId}`,
                    payload
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    data: response.data.data,
                    message:
                        response.data
                            .message,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.message ||
                    "Unexpected response from server",
            };
        } catch (error) {
            console.error(
                "Error updating commission rule:",
                error
            );

            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.response
                        ?.data
                        ?.message ||
                    error.message ||
                    "Failed to update commission rule",
            };
        }
    };

export const deleteCommissionRule =
    async (
        commissionRuleId
    ) => {
        try {
            const response =
                await api.delete(
                    `/commission-rule-management/commission-rules/${commissionRuleId}`
                );

            if (
                response.status ===
                    200 &&
                response.data.success
            ) {
                return {
                    success: true,
                    message:
                        response.data
                            .message,
                };
            }

            return {
                success: false,
                error:
                    response.data
                        ?.message ||
                    "Unexpected response from server",
            };
        } catch (error) {
            console.error(
                "Error deleting commission rule:",
                error
            );

            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.response
                        ?.data
                        ?.message ||
                    error.message ||
                    "Failed to delete commission rule",
            };
        }
    };